import request from '../helpers/request';

const updateRequestExecuter = async (requestId, executerId) => {
  return await request.put(
    `/Request/set_executer/${requestId}`,
    executerId,
    'Не удалось назначить исполнителя'
  );
};

export default updateRequestExecuter;
